import { createApi } from '@reduxjs/toolkit/query/react'
import { createApiConfig } from '../../../createApiConfig'

export const lMUgcSearchApi = createApi({
  reducerPath: 'lMUgcSearchApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['UgcSearchLinks'],
  endpoints: builder => ({
    getUgcSearchLinks: builder.query({
      query: (params) => ({
        url: `/links/ugc-search-level/`,
        params,
      }),
      providesTags: ['UgcSearchLinks']
    }),
    getUgcSearchAggregateLinks: builder.query({
      query: (params) => ({
        url: `/links/ugc-search-level/aggregate-by-campaign/`,
        params
      }),
      providesTags: ['UgcSearchLinks']
    }),
    getUgcSearchAggregateDomain: builder.query({
      query: ({ campaignId, ...params }) => ({
        url: `/links/ugc-search-level/${campaignId}/aggregate-by-domain/`,
        params,
      }),
      providesTags: ['UgcSearchLinks']
    }),
    markUgcSearch: builder.mutation({
      query: body => ({
        url: `/links/ugc-search-level/mark/`,
        method: 'POST',
        body
      }),
      invalidatesTags: ['UgcSearchLinks']
    })
  })
})

export const {
  useGetUgcSearchLinksQuery,
  useGetUgcSearchAggregateLinksQuery,
  useGetUgcSearchAggregateDomainQuery,
  useMarkUgcSearchMutation,
} = lMUgcSearchApi
